import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import RiskRibbon from "../../risk/RiskRibbon";
import {HashLink as Link} from "react-router-hash-link";


const Tile = (props) => {

    // const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);

    // const {portfolios, loadingPortfolios, loadingPortfoliosError, selfEntityId, loadingCycleDetails, loadingCycleDetailsError} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    let entityWithHighest = null;
    let highestNumber= null;

    const valueFunction = (stateData) => {

        if (stateData && stateData[customerIdToUse]) {

            try {

                const {
                    [customerIdToUse] : {
                        entities
                    }
                } = stateData

                // console.log("Most Humans here are the entities", entities);

                //figure out which entity has the largest number of targets in the last cycle

                // console.group("Looking for the entity with the highest number of humans.")
                for(const entityId in entities) {
                    const thisEntityNum = entities[entityId].last_cycle ? entities[entityId].last_cycle.identities : null;
                    if (!highestNumber || thisEntityNum > highestNumber) {
                        highestNumber = thisEntityNum;
                        entityWithHighest = entities[entityId];
                        // console.log("highest number of targets is", highestNumber, "from entity", entityWithHighest);
                    }
                }
                // console.groupEnd();

                if (entityWithHighest) {
                    return <>
                        <Link smooth to={`Details/Scores?entityID=${entityWithHighest.id}`} style={{ textDecoration: "none", color: "black" }}>
                            <h1>{highestNumber ? `${highestNumber}` : "Pending..."}</h1>
                            <h4>{`Humans Detected`}</h4>
                            <div>{entityWithHighest.name}</div>
                        </Link>
                    </>;
                } else {
                    return "Pending..."
                }

            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }

    }

    const riskRibbon = (stateData) => {

        return <RiskRibbon
            titleOverride={"Most Humans"}
            tipTextOverride={`We detected the most humans at this company.`}
            styleName = {""}
        />
    }

    return (
        <DataTile
            // color = {colorFunction()}
            // colorBgFunction={colorFunction}
            subTitle={" "}
            tipText={`Number of human targets represent potential for external or internal threats.`}
            icon={<></>}
            // iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="breachrisk"
            stateElement="portfolios"
            //useDeepDataStore
            dontFetch
            // forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && !loadingCycleDetails[myEntity.settings.last_cycle_id] && techData ? false : true}
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            // stateLoaderName="loadingTargets"
            // stateLoaderError="loadingTargetsError"
            // stateFetchAction={fetchTargets(
            //     {
            //         customerId: customerIdToUse
            //     }
            // )}
            // preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            // requiresModule={"monitor"}
        />
    )

}

export default Tile;